import React, { useEffect, useRef } from 'react';
import { FaArrowRight, FaCalendarAlt, FaRobot, FaChartLine, FaUsers, FaPlay } from 'react-icons/fa';
import { LuSparkles, LuMousePointerClick } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import backgroudimg from '../assets/homebg.7bffa0701dba3b32ff9f.jpg'
const Hero = () => {
  const heroRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
        }
      });
    }, { threshold: 0.1 });

    const elements = heroRef.current?.querySelectorAll('.fade-up, .fade-left, .fade-right');
    elements?.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleGetStarted = () => {
    navigate('/get-started');
  };

  return (
    <section
      id="home"
      ref={heroRef}
      className="pt-32 pb-20 md:pt-40 md:pb-28 relative overflow-hidden bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${backgroudimg})` }}
    >
      {/* Animated Background Elements */}
      <div className="absolute top-40 -left-20 w-96 h-96 bg-purple-600/30 rounded-full blur-[100px] animate-pulse"></div>
      <div className="absolute bottom-20 right-0 w-96 h-96 bg-blue-600/20 rounded-full blur-[100px] animate-pulse animation-delay-1000"></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-purple-500/10 to-blue-500/10 rounded-full blur-[120px]"></div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-2">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="fade-up">
            {/* <div className="inline-flex items-center gap-2 bg-gradient-to-r from-purple-500/20 to-indigo-500/20 rounded-full px-4 py-1.5 border border-purple-500/30 mb-6 hover:scale-105 transition-all duration-300 cursor-pointer group">
              <LuSparkles className="text-yellow-300 group-hover:rotate-12 transition-transform" />
              <span className="text-sm font-medium">AI-powered Prospecting Engine 2.0</span>
            </div> */}

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight">
              Intelligent Software 
              <span className="gradient-text relative inline-block pb-2">
                Automated Operations.
                <svg
                  className="absolute top-full left-0 mt-1 w-full"
                  height="4"
                  viewBox="0 0 200 4"
                >
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#A855F7" />
                    <stop offset="100%" stopColor="#3B82F6" />
                  </linearGradient>
                
                </svg>
              </span>{' '}
              
            </h1>

            <p className="text-gray-400 text-lg mt-6 max-w-lg leading-relaxed">
              We design and build      
              <span className="text-purple-400 font-semibold"> intelligent software  </span>systems that
              <span className="text-purple-400 font-semibold"> automate business operations </span> and 
              <span className="text-purple-400 font-semibold"> enable digital transformation </span>from scratch.
            </p>

            <div className="flex flex-wrap gap-4 mt-8">
              <button className="btn-primary flex items-center gap-2 text-lg px-8 py-3 group" onClick={handleGetStarted}>
                Book a Demo
                <FaArrowRight className="group-hover:translate-x-1 transition-transform duration-300" />
              </button>
              <button className="btn-secondary flex items-center gap-2 text-lg px-8 py-3 group">
                <FaPlay className="text-sm group-hover:scale-110 transition-transform" />
                Get Started Free
              </button>
            </div>

            <div className="flex items-center gap-4 mt-8 text-sm text-gray-400">
              <span className="flex items-center gap-1 group hover:text-green-400 transition">
                <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                 ENTERPRISE SOFTWARE
              </span>
              <span className="flex items-center gap-1 group hover:text-green-400 transition">
                 AI AUTOMATION
              </span>
              <span className="flex items-center gap-1 group hover:text-green-400 transition">
                 SAAS PLATFORMS
              </span>
              <span className="flex items-center gap-1 group hover:text-green-400 transition">
                 IOT SOLUTIONS
              </span>
            </div>

            {/* Scroll Indicator */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 hidden lg:block">
              <div className="animate-scroll-indicator">
                <LuMousePointerClick className="text-gray-400 text-xl" />
              </div>
            </div>
          </div>

          {/* Right Mockup Dashboard */}


          <div className="relative fade-right">

            {/* <div className="glass-card rounded-2xl p-4 shadow-2xl border border-white/20 hover:border-purple-500/50 transition-all duration-500 hover:scale-105 cursor-pointer group">
              <div className="bg-gradient-to-br from-indigo-900/40 to-black/60 rounded-xl p-4 flex flex-col gap-3">
                <div className="flex gap-2 text-sm">
                  <div className="w-3 h-3 rounded-full bg-red-400 animate-pulse"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                  <div className="w-3 h-3 rounded-full bg-green-400"></div>
                </div>

                <div className="bg-white/5 p-4 rounded-lg hover:bg-white/10 transition-all duration-300">
                  <div className="flex justify-between items-center">
                    <span className="font-mono text-sm">🔍 AI Prospect Discovery</span>
                    <FaRobot className="text-purple-400 group-hover:rotate-12 transition-transform duration-300" />
                  </div>
                  <div className="h-2 w-full bg-gray-700 rounded-full mt-3 overflow-hidden">
                    <div className="w-3/4 h-full bg-gradient-to-r from-purple-500 to-indigo-500 rounded-full animate-pulse relative">
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/50 to-transparent animate-shimmer"></div>
                    </div>
                  </div>
                  <p className="text-xs mt-2 text-gray-400">Analyzing 12,300+ companies...</p>
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div className="bg-white/5 p-3 rounded-lg hover:bg-white/10 transition-all duration-300 group/card">
                    <FaUsers className="text-indigo-400 text-xl mb-1 group-hover/card:scale-110 transition-transform" />
                    <p className="text-sm font-semibold">+240 leads</p>
                    <p className="text-xs text-gray-400">today</p>
                  </div>
                  <div className="bg-white/5 p-3 rounded-lg hover:bg-white/10 transition-all duration-300 group/card">
                    <FaChartLine className="text-green-400 text-xl mb-1 group-hover/card:scale-110 transition-transform" />
                    <p className="text-sm font-semibold">87%</p>
                    <p className="text-xs text-gray-400">engagement</p>
                  </div>
                </div>
              </div>
            </div> */}

            {/* Floating Stats */}

            {/* <div className="absolute -top-5 -right-5 glass-card p-3 rounded-xl animate-float hidden lg:block">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-xs font-semibold">Live: 247 prospects</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;